import React, { useState } from "react";
import { Button, Col, Row, Tab, Tabs } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClipboard, faUsers } from "@fortawesome/free-solid-svg-icons";
import { faAirbnb } from "@fortawesome/free-brands-svg-icons";
import AirbnbList from "./AirbnbList";
import AirbnbReports from "./Reports/AirbnbReports";

const Airbnb = ({ toAddMaid, toDeleteMaid, toDownload, isAdmin }) => {
  const [activeScreen, setActiveScreen] = useState("airbnb");
  return (
    <>
      <Row className="my-4 justify-content-center">
        <Col xs={4}>
          <Button
            className="py-2 px-3 rounded-4 w-100"
            variant={
              activeScreen === "airbnb" ? "primary" : "outline-secondary"
            }
            onClick={() => setActiveScreen("airbnb")}
          >
            <FontAwesomeIcon icon={faAirbnb} className="me-2" />
            Airbnb units
          </Button>
        </Col>
        <Col xs={4}>
          <Button
            className="py-2 px-3 rounded-4 w-100"
            variant={
              activeScreen === "reports" ? "primary" : "outline-secondary"
            }
            onClick={() => setActiveScreen("reports")}
          >
            <FontAwesomeIcon icon={faClipboard} className="me-2" />
            Reports
          </Button>
        </Col>
      </Row>
      <Row className="">
        <Col>
          {activeScreen === "airbnb" && (
            <AirbnbList toAddMaid={toAddMaid} toDeleteMaid={toDeleteMaid} />
          )}
          {activeScreen === "reports" && (
            <AirbnbReports
              toDownload={toDownload}
              isAdmin={isAdmin}
              type={"airbnb"}
            />
          )}
        </Col>
      </Row>
    </>
  );
};

export default Airbnb;
